<div *ngIf="show" class="col-md-6 row">
    <div class="card">
        <div class="card-header">Chat</div>
        <div class="card-body height3">
            <ul class="chat-list" *ngFor="let message of messages">
                <div class="chat-img">
                    <img alt="Avtar" width="24px" height="24px" *ngIf="message.sentBy === 'user'"
                        src="../../../../assets/img/usr.jpg">
                    <img alt="Avtar" width="24px" height="24px" *ngIf="message.sentBy !== 'user'"
                        style="float: right; margin-right: 30px; text-align: right;"
                        src="../../../../assets/img/manax.png">
                </div>
                <div class="chat-body">
                    <div class="chat-message">
                        <h5 *ngIf="message.sentBy === 'user'">User</h5>
                        <h5 *ngIf="message.sentBy !== 'user'"
                            style="float: right; margin-right: 20px; text-align: right;">
                            Manaxito</h5>
                        <br>
                        <p *ngIf="message.sentBy === 'user'">{{ message.text }}</p>
                        <p *ngIf="message.sentBy !== 'user'"
                            style="float: right; margin-right: 20px; text-align: right;">{{
                            message.text }}</p>
                    </div>
                </div>
            </ul>
        </div>
    </div>
    <div class="col-md-6 fixed-bottom">
        <div class="input-group mb-3">
            <input type="text" class="form-control" [(ngModel)]="newMessage" (keyup.enter)="sendMessage()"
                placeholder="Escribe tu consulta...">
            <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                (click)="sendMessage()">Enviar</button>
        </div>
    </div>
</div>